import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { TranslationService } from "src/app/i18n";

@Component({
  selector: "app-lang-switcher",
  templateUrl: "./lang-switcher.component.html",
  styleUrls: ["./lang-switcher.component.scss"],
  imports: [CommonModule],
})
export class LangSwitcherComponent {
  @Input() toggleBtnClass = "";
  @Input() toggleBtnIconClass = "svg-icon-2";
  @Input() menuPlacement = "bottom-end";
  @Input() menuTrigger = "{default: 'click', lg: 'hover'}";
  lang = "";

  private readonly translationService = inject(TranslationService);

  constructor() {
    this.lang = this.translationService.getSelectedLanguage();
  }

  switchLang(lang: string): void {
    this.translationService.setLanguage(lang);
    window.location.reload();
  }
}
